module.exports = __webpack_public_path__ + "img/six-round.af76ab3f.svg";